import { Select } from "antd";
import { useEffect, useState } from "react";
import * as API from "@api";

export default function Countries(params) {
  const [data, setData] = useState([]);

  useEffect(() => {
    API.Countries.getAll({ limit: 1000 }).then((res) =>
      setData(
        res?.data?.rows?.map((country) => ({
          label: country?.name,
          value: country?.id,
        })) || []
      )
    );
  }, []);

  return (
    <Select
      mode="multiple"
      className="w-full"
      placeholder="Select Country"
      allowClear
      showSearch
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label ?? "").toLowerCase())
      }
      onChange={(v) => params.onChange("country_id", v)}
      options={data}
    />
  );
}
